module.exports = __webpack_public_path__ + "img/image12.74b2648b.png";